import ABTest  from './components/abtest';
import ABTestRedirect from './components/abtest-redirect'


export default ABTest;

export {
	ABTestRedirect
};
